import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import MainCta from '../botones/main-cta'
import Multicanalidad from '../botones/multicanalidad2'
import Casa from '../../../static/images/hipotecario/iconos/landing-hipotecario-icono-1.svg'

const Container = styled.div`
  background: ${props => props.theme.colors.grisClaro};
  background:#eae9eb;
  position: relative;
  text-align: center;
  margin: 0 auto;

  h1 {
    font-size: 2em;
    margin: 0 0 0.3em;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

  ${breakpoint('desktop')`
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;

    & > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 50%;
      max-width: 500px;
      box-sizing: border-box;
    }

    & > div:first-of-type {
      padding-right: 20px;
    }
  `}
`

const H1 = styled.h1 `
    margin-top: -17px !important;
    font-weight: 600;
`

const ImageHipo = styled.img `
    width: 300px;
    margin: 0 auto;
    display: block;

    ${breakpoint('tablet')`
        margin: -30px auto;
    `}
        
`
const ContentH3 = styled.div `
    margin: 0 auto;
    display: block;
    margin-top: 20px;
   

    ${breakpoint('tablet')`
        margin-left:20px;
        padding: 9px;
        padding-left: 50px;
        margin-top: 35px;
    `}
`

const H3 = styled.h3 `
    margin-top: -17px;
    font-weight: 400;
`

const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
      <div>
        {/* <h1>
          Solicit{["CRI", "NIC"].includes(pais.contryAbr) ? "á" : "a"} tu
          tarjeta
        </h1> */}
        <h1 style={{fontWeight: 600}}>Tu hipoteca</h1>
        <H1>está en las</H1>
        <H1>mejores manos</H1>
        {/* <h2>Fácil. Rápido. Seguro.</h2> */}
        {multicanalidad == null ? (
          <MainCta to={formUrl}>
            Llen{["CRI", "NIC"].includes(pais.contryAbr) ? "á" : "a"} el
            formulario
          </MainCta>
        ) : (
          <Multicanalidad multicanalidad={multicanalidad} />
        )}
        {/* <p>
          Y {["CRI", "NIC"].includes(pais.contryAbr) ? "recibila" : "recíbela"}{" "}
          en tu casa u oficina
        </p> */}
      </div>
      <div>
          <div>
            <ImageHipo alt="Hipotecario" src={Casa}></ImageHipo>
            <ContentH3>
                <h3 style={{fontWeight:400}}>Nuestro compromiso no se acaba</h3>
                <H3>cuando te damos tu crédito de </H3>
                <H3>vivienda. Queremos ir más allá y </H3>
                <H3>ayudarte en todo lo que vos necesités. </H3>
            </ContentH3>
          </div>
        {/* <video autoPlay loop muted playsInline id="vid">
          <source
            src="https://seguridad.baccredomatic.com/files/sandbox/cr/video_-_julio_2018_-_hero_form_-_compu_-_1.mp4?autoplay=1"
            type="video/mp4"
          />
          <source
            src="https://seguridad.baccredomatic.com/files/sandbox/cr/video_-_julio_2018_-_hero_form_-_compu_-_1.ogv?autoplay=1"
            type="video/ogv"
          />
          <source
            src="https://seguridad.baccredomatic.com/files/sandbox/cr/video_-_julio_2018_-_hero_form_-_compu_-_1.webm?autoplay=1"
            type="video/webm"
          />
          <img src={image} alt="Solicitá tu tarjeta" />
        </video> */}
      </div>
    </Wrapper>
  </Container>
);

export default Header